import store from "@/store";
import {
  USER_GROUP_GUEST,
  USER_GROUP_PERSON,
  USER_GROUP_ARTIST
} from "@/constants";

export default class AccessControl {
  static is(accessLevel = 0) {
    if (accessLevel === USER_GROUP_GUEST) {
      return true;
    }

    const authenticated = store.getters["user/authenticated"];
    const userGroup = store.getters["user/group"];
    const accessible = userGroup >= accessLevel && authenticated;

    return accessible;
  }
  static route(accessLevel, options = {}) {
    return function(to, from, next) {
      if (AccessControl.is(accessLevel)) {
        if ("owner" in options) {
          const { owner } = options;
          const id = to.params[owner.paramName];

          if (AccessControl.owner(owner.pageType, id)) {
            return next();
          }
        } else {
          return next();
        }
      }

      store.dispatch("page/setErrorCode", "notFound");
      store.dispatch("page/setStatus", "error");

      return next();
    };
  }
  static owner(type, itemId) {
    const lib = {
      albums: [],
      singles: [],
      playlists: store.getters["playlists/playlistsArray"].map(({ id }) => id)
    };

    // TODO: добавить запрос на проверку доступа

    return lib[type] ? lib[type].includes(itemId) : false;
  }
  static getPlugin() {
    return {
      install(app) {
        app.prototype.$accessControl = AccessControl;
        app.prototype.USER_GROUP_GUEST = USER_GROUP_GUEST;
        app.prototype.USER_GROUP_PERSON = USER_GROUP_PERSON;
        app.prototype.USER_GROUP_ARTIST = USER_GROUP_ARTIST;
      }
    };
  }
}
